import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { persistState } from '@datorama/akita';

import { Amplify } from 'aws-amplify';
import { platformBrowser } from '@angular/platform-browser';

Amplify.configure({
  Auth: {
    Cognito: {
      identityPoolId: environment.aws.identityPoolId,
      userPoolId: environment.aws.userPoolId,
      userPoolClientId: environment.aws.userPoolWebClientId,
    },
  },
});
const storage = persistState();
const providers = [{ provide: 'persistStorage', useValue: storage }];

if (environment.production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection(), ...providers] })
  .catch((err) => console.error(err));
